( function () {
  'use strict';

  var reduced =
    window.matchMedia &&
    window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

  function productHref( trigger ) {
    if ( ! trigger ) {
      return '';
    }
    if ( trigger.tagName === 'A' ) {
      return trigger.getAttribute( 'href' ) || '';
    }
    return trigger.getAttribute( 'data-cap-viewer-href' ) || '';
  }

  function isProductHref( href ) {
    if ( ! href || href === '#' || href.indexOf( 'javascript:' ) === 0 ) {
      return false;
    }
    try {
      var url = new URL( href, window.location.href );
      if ( url.origin === window.location.origin &&
        url.pathname === window.location.pathname &&
        ! url.search &&
        ( ! url.hash || url.hash === '#' ) ) {
        return false;
      }
    } catch ( err ) {
      return true;
    }
    return true;
  }

  function initCapViewer() {
    var modal = document.querySelector( '[data-cap-viewer-modal]' );
    if ( ! modal || typeof modal.showModal !== 'function' ) {
      return;
    }

    var titleEl = modal.querySelector( '[data-cap-viewer-title]' );
    var continueEl = modal.querySelector( '[data-cap-viewer-continue]' );
    var codeEl = modal.querySelector( '[data-hero-code]' );
    var photoEl = modal.querySelector( '[data-hero-cap-photo]' );
    var lastFocus = null;

    function closeModal() {
      if ( modal.open ) {
        modal.close();
      }
    }

    function openModal( trigger ) {
      var title = trigger.getAttribute( 'data-cap-viewer-title' ) || 'Pattern on cap';
      var code = ( trigger.getAttribute( 'data-cap-viewer-code' ) || '' ).trim();
      var href = productHref( trigger );

      if ( titleEl ) {
        titleEl.textContent = title;
      }
      if ( codeEl ) {
        codeEl.textContent = code;
        if ( code ) {
          codeEl.removeAttribute( 'hidden' );
        } else {
          codeEl.setAttribute( 'hidden', '' );
        }
      }
      if ( continueEl ) {
        if ( isProductHref( href ) ) {
          continueEl.setAttribute( 'href', href );
          continueEl.removeAttribute( 'hidden' );
        } else {
          continueEl.setAttribute( 'href', '#' );
          continueEl.setAttribute( 'hidden', '' );
        }
      }
      if ( photoEl ) {
        var photo = trigger.getAttribute( 'data-cap-viewer-image' ) || '';
        if ( photo ) {
          photoEl.setAttribute( 'href', photo );
          photoEl.setAttributeNS( 'http://www.w3.org/1999/xlink', 'href', photo );
          photoEl.style.display = '';
        } else {
          photoEl.style.display = 'none';
        }
      }

      lastFocus = document.activeElement;
      modal.showModal();
      if ( reduced ) {
        modal.classList.add( 'cap-viewer-modal--static' );
      }
    }

    document.addEventListener( 'click', function ( event ) {
      var trigger = event.target.closest( '[data-cap-viewer-trigger]' );
      if ( ! trigger ) {
        return;
      }
      if ( event.defaultPrevented ) {
        return;
      }
      if ( event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ) {
        return;
      }
      event.preventDefault();
      openModal( trigger );
    } );

    modal.querySelectorAll( '[data-cap-viewer-close]' ).forEach( function ( btn ) {
      btn.addEventListener( 'click', closeModal );
    } );

    modal.addEventListener( 'click', function ( event ) {
      if ( event.target === modal ) {
        closeModal();
      }
    } );

    modal.addEventListener( 'close', function () {
      if ( lastFocus && typeof lastFocus.focus === 'function' ) {
        lastFocus.focus();
      }
    } );

    document.addEventListener( 'keydown', function ( event ) {
      if ( event.key === 'Escape' && modal.open ) {
        event.preventDefault();
        closeModal();
      }
    } );
  }

  document.addEventListener( 'DOMContentLoaded', initCapViewer );
}() );
